function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_documentacao_a,.icon_menu_documentacao_e{fill:#fff;}\n      .icon_menu_documentacao_a{stroke:#707070;}\n      .icon_menu_documentacao_b{clip-path:url(#icon_menu_documentacao_a);}\n      .icon_menu_documentacao_c{fill:#90a4ae;}\n      .icon_menu_documentacao_d{fill:#607d8b;}\n      .icon_menu_documentacao_f{fill:#7d8f97;}\n      .icon_menu_documentacao_g{fill:#546d79;}\n      .icon_menu_documentacao_h{fill:#dedede;}\n      .icon_menu_documentacao_i{fill:#2196f3;}\n      .icon_menu_documentacao_j{fill:#ffc107;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_documentacao_a"
}, React.createElement("rect", {
  className: "icon_menu_documentacao_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1048)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_documentacao_b",
  transform: "translate(-1800 -1048)"
}, React.createElement("g", {
  transform: "translate(1800 1046.417)"
}, React.createElement("path", {
  className: "icon_menu_documentacao_c",
  d: "M12.551,18.324a3.3,3.3,0,0,1-1.072-2.1.4.4,0,0,0-.4-.393H7.9a.4.4,0,0,0-.4.4A3.223,3.223,0,0,1,6.45,18.324.4.4,0,0,0,6.729,19h5.542a.4.4,0,0,0,.28-.676Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_d",
  d: "M17.615,3.167H1.385A1.387,1.387,0,0,0,0,4.552V15.24a1.387,1.387,0,0,0,1.385,1.385H17.615A1.387,1.387,0,0,0,19,15.24V4.552A1.387,1.387,0,0,0,17.615,3.167Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_e",
  d: "M17.417,13.458H1.583V4.75H17.417Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_f",
  d: "M9.5,16.625H7.449a3.589,3.589,0,0,1-1,1.7A.4.4,0,0,0,6.729,19H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_g",
  d: "M9.5,3.167H1.385A1.387,1.387,0,0,0,0,4.552V15.24a1.387,1.387,0,0,0,1.385,1.385H9.5V13.458H1.583V4.75H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_h",
  d: "M9.5,4.75H1.583v8.708H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_i",
  d: "M6.333,5.542V8.708l-2.24,2.24a3.167,3.167,0,1,0,2.24-5.407Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_j",
  d: "M3.167,8.708a3.187,3.187,0,0,0,.926,2.24l2.24-2.24V5.542A3.166,3.166,0,0,0,3.167,8.708Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_c",
  d: "M15.042,7.917H11.875a.792.792,0,0,1,0-1.583h3.167a.792.792,0,1,1,0,1.583Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_c",
  d: "M15.042,11.083H11.875a.792.792,0,0,1,0-1.583h3.167a.792.792,0,0,1,0,1.583Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_f",
  d: "M13.458,6.333H11.875a.792.792,0,0,0,0,1.583h1.583Z"
}), React.createElement("path", {
  className: "icon_menu_documentacao_f",
  d: "M13.458,9.5H11.875a.792.792,0,0,0,0,1.583h1.583Z"
})));

var SvgDocumentacao = function SvgDocumentacao(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocumentacao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documentacao.826044c4.svg";
export { ForwardRef as ReactComponent };